<template>
  <div v-if="inline" class="fr stack">
    <span class="fr-label" :class="{ req: required }">{{ label }}</span>
    <div class="mini-chips">
      <button v-for="item in options" :key="String(item.value)" type="button" :class="{ on: isOn(item.value) }" :disabled="disabled" :aria-pressed="isOn(item.value) ? 'true' : 'false'" @click="choose(item.value)">
        {{ item.label }}
      </button>
    </div>
  </div>
  <div v-else class="fr">
    <span class="fr-label" :class="{ req: required }">{{ label }}</span>
    <button type="button" class="fr-value" :disabled="disabled" :aria-label="label + '：' + (text || placeholder)" @click="open = true">
      <span class="txt" :class="{ ph: !text }">{{ text || placeholder }}</span>
      <small v-if="hint">{{ hint }}</small>
      <app-icon name="arrow" />
    </button>
    <picker-sheet :show="open" :title="title || label" :subtitle="subtitle" :value="value" :options="options" :multiple="multiple" :searchable="options.length > 10" @input="$emit('input', $event)" @close="open = false" />
  </div>
</template>
<script>
import PickerSheet from './picker-sheet'
// 选项不多时直接铺开，一次点选完成；选项多时用底部面板
export default {
  components: { PickerSheet },
  props: {
    label: String,
    value: { type: [String, Number, Array], default: '' },
    options: { type: Array, default: () => [] },
    required: Boolean,
    multiple: Boolean,
    title: String,
    subtitle: String,
    placeholder: { type: String, default: '请选择' },
    inlineMax: { type: Number, default: 8 },
    disabled: Boolean,
    clearable: { type: Boolean, default: true }
  },
  data() {
    return { open: false }
  },
  computed: {
    inline() {
      return !this.multiple && this.options.length <= this.inlineMax
    },
    selected() {
      const values = Array.isArray(this.value) ? this.value.map(String) : [String(this.value)]
      return this.options.filter(item => values.indexOf(String(item.value)) >= 0)
    },
    text() {
      if (this.value === '' || this.value === null || this.value === undefined) return ''
      if (this.multiple) {
        if (!this.selected.length) return ''
        return this.selected.length > 2
          ? this.selected[0].label + ' 等 ' + this.selected.length + ' 个'
          : this.selected.map(item => item.label).join('、')
      }
      return this.selected.length ? this.selected[0].label : ''
    },
    hint() {
      return !this.multiple && this.selected.length ? this.selected[0].hint : ''
    }
  },
  methods: {
    isOn(value) {
      return this.value !== '' && this.value !== null && this.value !== undefined && String(this.value) === String(value)
    },
    choose(value) {
      // 选填项再点一次可以清空
      this.$emit('input', this.isOn(value) && !this.required && this.clearable ? '' : value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/select-field.vue